"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaskWorkflow = void 0;
const useWorkflowItem_1 = require("../../hooks/useWorkflowItem");
function useTaskWorkflow(task, params) {
    const item = (0, useWorkflowItem_1.useWorkflowItem)(task, params);
    return item === null || item === void 0 ? void 0 : item.workflow;
}
exports.useTaskWorkflow = useTaskWorkflow;
//# sourceMappingURL=useTaskWorkflow.js.map